import { CollapsableAnd } from '../../Shared/CollapsableAnd';

export const Step1Text = {
  Button: {
    Next: () => (
      <span>
        <strong>NEXT:</strong> Investments <CollapsableAnd /> schedule
      </span>
    ),
  },
  Title: () => <span>Choose delivery method for your assets</span>,
};

export const Step2Text = {
  Button: {
    Next: () => (
      <span>
        <strong>NEXT:</strong> Tax Withholding
      </span>
    ),
  },
  Title: () => (
    <span>
      Select investment(s){' '}
      <span className="hidden-xs">
        {' '}
        to sell <CollapsableAnd /> schedule
      </span>
    </span>
  ),
};

export const Step3Text = {
  Button: {
    Next: () => (
      <span>
        <strong>NEXT:</strong> Review
      </span>
    ),
  },
  Title: () => <span>Determine federal income tax withholding</span>,
};

export const Step4Text = {
  Button: {
    Next: () => (
      <span>
        <strong>SUBMIT</strong>
      </span>
    ),
  },
  Title: () => <span>Review your automatic sell</span>,
};
